import React, { Component } from 'react';
import loadjs from 'loadjs';
import { Link } from 'react-router-dom';

export default class Checkout extends Component {
    componentWillMount() {
        loadjs("/js/main.js")
    }
    
    render() {
        return (
            <React.Fragment>
                <section class="home-slider owl-carousel">
                    <div class="slider-item" style={{"backgroundImage": "url('/images/bg_3.jpg')"}} data-stellar-background-ratio="0.5">
                        <div class="overlay"></div>
                        <div class="container">
                            <div class="row slider-text justify-content-center align-items-center">
                                <div class="col-md-7 col-sm-12 text-center ftco-animate">
                                    <h1 class="mb-3 mt-5 bread">Checkout</h1>
                                    <p class="breadcrumbs"><span class="mr-2"><Link to="/">Home</Link></span> <span>Checkout</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="ftco-section">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-8 ftco-animate">
                                <form action="#" class="billing-form ftco-bg-dark p-3 p-md-5">
                                    <h3 class="mb-4 billing-heading">Billing Details</h3>
                                    <div class="row align-items-end">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="firstname">Firt Name</label>
                                                <input type="text" class="form-control" placeholder="" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="lastname">Last Name</label>
                                                <input type="text" class="form-control" placeholder="" />
                                            </div>
                                        </div>
                                        <div class="w-100"></div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="country">State / Country</label>
                                                <div class="select-wrap">
                                                    <div class="icon"><span class="ion-ios-arrow-down"></span></div>
                                                    <select name="" id="" class="form-control">
                                                        <option value="">France</option>
                                                        <option value="">Italy</option>
                                                        <option value="">Philippines</option>
                                                        <option value="">South Korea</option>
                                                        <option value="">Hongkong</option>
                                                        <option value="">Japan</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-100"></div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="streetaddress">Street Address</label>
                                                <input type="text" class="form-control" placeholder="House number and street name" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input type="text" class="form-control" placeholder="Appartment, suite, unit etc: (optional)" />
                                            </div>
                                        </div>
                                        <div class="w-100"></div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="towncity">Town / City</label>
                                                <input type="text" class="form-control" placeholder="" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="postcodezip">Postcode / ZIP *</label>
                                                <input type="text" class="form-control" placeholder="" />
                                            </div>
                                        </div>
                                        <div class="w-100"></div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="phone">Phone</label>
                                                <input type="text" class="form-control" placeholder="" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="emailaddress">Email Address</label>
                                                <input type="text" class="form-control" placeholder=""/>
                                            </div>
                                        </div>
                                        <div class="w-100"></div>
                                        <div class="col-md-12">
                                            <div class="form-group mt-4">
                                                <div class="radio">
                                                    <label class="mr-3"><input type="radio" name="optradio"/> Create an Account? </label>
                                                    <label><input type="radio" name="optradio"/> Ship to different address</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="col-xl-4 sidebar ftco-animate">
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        )
    }
}